import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "18", x: "3", y: "3", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "10", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UserSquare";
const UserSquare = memo(themed(Icon));
export {
  UserSquare
};
//# sourceMappingURL=user-square.js.map
